import { Color, CssClassMap } from '../interface';

/**
 * Create the mode and color classes for the component based on the classes passed in
 */
export function createColorClasses(color: Color | undefined | null): CssClassMap | undefined {
  return (typeof color === 'string' && color.length > 0) ? {
    'lar-color': true,
    [`lar-color-${color}`]: true
  } : undefined;
}
/**
 * Larva app selector wheret to append dynamic components
 */
export function getAppRoot(doc: Document) {
  return doc.querySelector('lar-app') || doc.body;
}
